import { setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UILanguageButtonController } from '../../../../shared/scripts/ui_popup/ui_language/UILanguageButtonController.ts';
export class UISidebarController {
    hide() {
        this.sidebars.forEach((sidebar)=>{
            sidebar.classList.add('hidden');
        });
    }
    show() {
        this.sidebars.forEach((sidebar)=>{
            sidebar.classList.remove('hidden');
        });
    }
    setActiveStateBasedOnUrl() {
        this.deactivateAllButtons();
        const pathname = window.location.pathname;
        const hash = window.location.hash;
        const isRoomUrl = pathname == '/' && hash != '';
        if (hash.includes('lobby=1') || isRoomUrl) {
            UISidebarController.activateButton(this.lobbyButtons);
        } else if (hash.includes('mainpage=1')) {
            UISidebarController.activateButton(this.playButtons);
        } else if (pathname.includes('/leaderboard')) {
            UISidebarController.activateButton(this.leaderboardButtons);
        } else if (pathname.includes('/store')) {
            UISidebarController.activateButton(this.storeButtons);
        } else if (pathname.includes('/more')) {
            UISidebarController.activateButton(this.moreButtons);
        } else if (pathname == '/' || pathname == '') {
            UISidebarController.activateButton(this.playButtons);
        }
    }
    setupHashChangeListener() {
        window.addEventListener('hashchange', ()=>{
            this.setActiveStateBasedOnUrl();
        });
    }
    setupLobbyAndPlayClickHandlers() {
        this.logoButtons.forEach((button)=>{
            setElementOnClick(button, ()=>{
                if (this.logoClickCallback) {
                    this.logoClickCallback();
                }
            });
        });
        this.lobbyButtons.forEach((button)=>{
            // eslint-disable-next-line no-restricted-syntax
            button.addEventListener('click', (event)=>{
                if (this.sceneNavigationCallback) {
                    event.preventDefault();
                    this.sceneNavigationCallback('lobby');
                }
            });
        });
        this.playButtons.forEach((button)=>{
            // eslint-disable-next-line no-restricted-syntax
            button.addEventListener('click', (event)=>{
                if (this.sceneNavigationCallback) {
                    event.preventDefault();
                    this.sceneNavigationCallback('play');
                }
            });
        });
    }
    setupLanguageButtonClickHandler() {
        this.sidebars.forEach((sidebar)=>new UILanguageButtonController(sidebar));
    }
    setSceneNavigationCallback(callback) {
        this.sceneNavigationCallback = callback;
    }
    setLogoClickCallback(callback) {
        this.logoClickCallback = callback;
    }
    deactivateAllButtons() {
        this.leaderboardButtons.forEach((button)=>{
            button.classList.remove('active');
        });
        this.lobbyButtons.forEach((button)=>{
            button.classList.remove('active');
        });
        this.playButtons.forEach((button)=>{
            button.classList.remove('active');
        });
        this.storeButtons.forEach((button)=>{
            button.classList.remove('active');
        });
        this.moreButtons.forEach((button)=>{
            button.classList.remove('active');
        });
    }
    static activateButton(buttons) {
        buttons.forEach((button)=>{
            button.classList.add('active');
        });
    }
    activateLeaderboard() {
        this.deactivateAllButtons();
        UISidebarController.activateButton(this.leaderboardButtons);
    }
    activateLobby() {
        this.deactivateAllButtons();
        UISidebarController.activateButton(this.lobbyButtons);
    }
    activatePlay() {
        this.deactivateAllButtons();
        UISidebarController.activateButton(this.playButtons);
    }
    activateStore() {
        this.deactivateAllButtons();
        UISidebarController.activateButton(this.storeButtons);
    }
    activateMore() {
        this.deactivateAllButtons();
        UISidebarController.activateButton(this.moreButtons);
    }
    constructor(){
        this.sidebars = document.querySelectorAll('.web-sidebar');
        this.leaderboardButtons = document.querySelectorAll('.web-sidebar-leaderboard');
        this.lobbyButtons = document.querySelectorAll('.web-sidebar-lobby');
        this.playButtons = document.querySelectorAll('.web-sidebar-play');
        this.storeButtons = document.querySelectorAll('.web-sidebar-store');
        this.moreButtons = document.querySelectorAll('.web-sidebar-more');
        this.logoButtons = document.querySelectorAll('.web-sidebar-logo');
        this.setActiveStateBasedOnUrl();
        this.setupHashChangeListener();
        this.setupLobbyAndPlayClickHandlers();
        this.setupLanguageButtonClickHandler();
    }
}
